module.exports = __webpack_public_path__ + "static/media/ShuffleboardTouchArea.ad6d84f3.png";